import { createIntl } from 'react-intl';
import * as yup from 'yup';

import de from '@src/translations/de.json';

import messages from './BusinessIntroductionDE.schema.messages';
import { intlCache } from '../LanguageProvider';

const intl = createIntl(
    {
        locale: 'de',
        messages: de
    },
    intlCache
);

function validateCompanyName(companyName) {
    const {
        context: { onManualCompanySearch, hasSearchResults },
        parent: { crefo_id: crefoId }
    } = this.options;

    const hasSelectedCompany = Boolean(crefoId);

    if (!onManualCompanySearch && !hasSelectedCompany && hasSearchResults) {
        return new yup.ValidationError(
            intl.formatMessage({ ...messages.pleaseSelectAnAnswer }),
            null,
            this.path
        );
    }

    if (companyName.length === 0) {
        return new yup.ValidationError(
            intl.formatMessage({ ...messages.companyNameError }),
            null,
            this.path
        );
    }

    return true;
}

const requiredOnManualCompanySearch = (yupType, requiredErrorMessage) =>
    yupType.when(['$onManualCompanySearch'], {
        is: true,
        then: () => yupType.required(requiredErrorMessage),
        otherwise: () => yupType
    });

const minDataReqCompanyInfoSchemaDE = yup.object().shape({
    crefo_id: yup.string(),
    company_name: yup
        .string()
        .test(
            'validateCompanyName',
            intl.formatMessage({ ...messages.companyNameError }),
            validateCompanyName
        )
        .required(intl.formatMessage({ ...messages.companyNameError })),
    annual_turnover: yup
        .string()
        .required(intl.formatMessage({ ...messages.estimatedTurnoverError })),
    registered: yup.object().shape({
        mm: yup
            .string()
            .required(intl.formatMessage({ ...messages.registeredDateError })),
        yy: yup
            .string()
            .required(intl.formatMessage({ ...messages.registeredDateError }))
            .min(4, 'Minimum 4')
            .max(4, 'Maximum 4')
            .matches(
                /^(19[0-9]\d|20[0-2]\d|2016)$/,
                intl.formatMessage({ ...messages.registeredDateError })
            )
    })
});

const signUpCompanyInfoSchemaDE = minDataReqCompanyInfoSchemaDE.shape({
    website: yup
        .string()
        .matches(
            /^$|((http|https)\:\/\/)?[a-zA-Z0-9\.\/\?\:@\-_=#]+\.([a-zA-Z0-9\&\.\/\?\:@\-_=#])*/,
            intl.formatMessage({ ...messages.websiteError })
        ),
    address: yup.object().shape({
        building_number: requiredOnManualCompanySearch(
            yup.string(),
            intl.formatMessage({ ...messages.houseNumberError })
        ),
        street_line_1: requiredOnManualCompanySearch(
            yup.string(),
            intl.formatMessage({ ...messages.streetOneError })
        ),
        street_line_2: yup.string(),
        postcode: requiredOnManualCompanySearch(
            yup
                .string()
                .matches(
                    /^[0-9]{2}[0-9]{3}$/,
                    intl.formatMessage({ ...messages.validPostcodeError })
                ),
            intl.formatMessage({ ...messages.noPostcodeError })
        ),
        town: requiredOnManualCompanySearch(
            yup.string(),
            intl.formatMessage({ ...messages.townError })
        )
    }),
    type: requiredOnManualCompanySearch(
        yup.string(),
        intl.formatMessage({ ...messages.pleaseSelectAnAnswer })
    )
});

export {
    minDataReqCompanyInfoSchemaDE as minDataReqCompanyInfoDE,
    signUpCompanyInfoSchemaDE as companyInfoDE
};
